import { render, staticRenderFns } from "./CompetitionsListComponent.vue?vue&type=template&id=5465c383&scoped=true&"
import script from "./CompetitionsListComponent.vue?vue&type=script&lang=ts&"
export * from "./CompetitionsListComponent.vue?vue&type=script&lang=ts&"
import style0 from "./CompetitionsListComponent.vue?vue&type=style&index=0&id=5465c383&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5465c383",
  null
  
)

export default component.exports